// src/state/soundState.js
import { safeGetJSON, safeSetJSON } from "./storage";

export const SOUND_STORAGE_KEY = "app_sound";

function clamp01(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return 1;
  return Math.max(0, Math.min(1, x));
}

export function readSoundSnapshot() {
  const stored = safeGetJSON(SOUND_STORAGE_KEY, null);
  const base = {
    masterVolume: 0.8,
    muted: false,
    bgmVolume: 0.8,
    sfxVolume: 0.9,
  };

  if (!stored || typeof stored !== "object") return base;

  return {
    masterVolume: clamp01(stored.masterVolume ?? base.masterVolume),
    muted: Boolean(stored.muted ?? base.muted),
    bgmVolume: clamp01(stored.bgmVolume ?? base.bgmVolume),
    sfxVolume: clamp01(stored.sfxVolume ?? base.sfxVolume),
  };
}

export function persistSound(state) {
  safeSetJSON(SOUND_STORAGE_KEY, state);
}

export function soundReducer(state, action) {
  switch (action.type) {
    case "SOUND/SET_MASTER": {
      const next = { ...state, masterVolume: clamp01(action.payload) };
      persistSound(next);
      return next;
    }
    case "SOUND/SET_MUTED": {
      const next = { ...state, muted: Boolean(action.payload) };
      persistSound(next);
      return next;
    }
    case "SOUND/SET_BGM": {
      const next = { ...state, bgmVolume: clamp01(action.payload) };
      persistSound(next);
      return next;
    }
    case "SOUND/SET_SFX": {
      const next = { ...state, sfxVolume: clamp01(action.payload) };
      persistSound(next);
      return next;
    }
    default:
      return state;
  }
}
